<template>
    <div class="text-sm mb-3">
        <md-tabs md-active-tab="tab-infos">
            <md-tab id="tab-infos" md-label="Informations">
                <div class="md-layout md-gutter mt-3">
                    <div class="md-layout-item md-size-50">
                        <div>
                            <span class="font-medium">Nom :</span>
                            <span class="ml-1">{{ site.name }}</span>
                        </div>
                        <div>
                            <span class="font-medium">Note :</span>
                            <span class="ml-1">{{ site.note ? site.note : 'Ø' }}</span>
                        </div>
                        <div class="mt-2">
                            <span class="font-medium">Adresse :</span>
                            <span class="ml-1">{{ address.addresses }}</span>
                        </div>
                        <div>
                            <span class="font-medium">Code postal :</span>
                            <span class="ml-1">{{ address.zip_code }}</span>
                        </div>
                        <div>
                            <span class="font-medium">Ville :</span>
                            <span class="ml-1">{{ address.city }}</span>
                        </div>
                        <div class="mt-2">
                            <span class="font-medium">Activité :</span>
                            <span class="ml-1">{{ activity.name }}</span>
                        </div>
                        <div>
                            <span class="font-medium">Secteur :</span>
                            <span class="ml-1">{{ sector.name }}</span>
                        </div>
                    </div>
                    <div class="md-layout-item md-size-50">
                        <div class="mb-2">
                            <span class="font-bold">Horaires d'intervention :</span>
                            <template v-if="schedules.length > 0">
                                <site-schedules :schedules="schedules"></site-schedules>
                            </template>
                            <span v-else class="ml-1">Ø</span>
                        </div>
                        <div>
                            <span class="font-bold">Horaires - Informations complémentaires :</span>
                            <p v-if="site.schedule_comment" class="mb-0">{{ site.schedule_comment }}</p>
                            <span v-else class="ml-1">Ø</span>
                        </div>
                    </div>
                </div>
				<md-divider class="my-3"></md-divider>
				<span class="font-medium text-info text-base">Contacts</span>
                <div class="md-layout md-gutter mt-1">
                    <div class="md-layout-item md-size-50">
                        <div>
                            <span class="font-bold">Responsable :</span>
                            <contacts-list :contacts="contactsList('Responsable')"></contacts-list>
                        </div>
                        <div>
                            <span class="font-bold">Donneur d'ordre :</span>
                            <contacts-list :contacts="contactsList('Donneur d\'ordre')"></contacts-list>
                        </div>
                    </div>
                    <div class="md-layout-item md-size-50">
                        <div>
                            <span class="font-bold">Contact RDV :</span>
                            <contacts-list :contacts="contactsList('Contact RDV')"></contacts-list>
                        </div>
                        <div>
                            <span class="font-bold">Autres :</span>
                            <contacts-list :contacts="contactsList('Autres')"></contacts-list>
                        </div>
                    </div>
                </div>
            </md-tab>
            <md-tab id="tab-devices" md-label="Dispositifs et Plans">
                <div class="md-layout md-gutter mt-1">
                    <div class="md-layout-item md-size-50">
                        <span class="text-base font-medium">Dispositifs</span>
                        <md-table v-model="devices" class="md-table-devices mt-1" table-header-color="blue" v-if="devices.length > 0">
                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                                <md-table-cell md-label="N°">
                                    <span>{{ item.number }}</span>
                                </md-table-cell>
                                <md-table-cell md-label="Type de dispositif">
                                    <div class="flex items-center">
                                        <img :src="item.device_types[(item.device_types.length - 1)].icon" alt="picto" />
                                        <span class="ml-3">{{ item.device_types[(item.device_types.length - 1)].name }}</span>
                                    </div>
                                </md-table-cell>
                            </md-table-row>
                        </md-table>
                        <p v-else>Aucun dispositif sur ce site</p>
                    </div>
                    <div class="md-layout-item md-size-50">
                        <span class="text-base font-medium">Plans</span>
                        <md-table v-model="plans" class="mt-1" table-header-color="blue" v-if="plans.length > 0">
                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                                <md-table-cell md-label="Nom">
                                    <a class="text-info" :href="item.url" target="_blank">
                                        {{ item.name }}
                                    </a>
                                </md-table-cell>
                                <md-table-cell md-label="">
                                    <div class="flex items-center justify-end">
                                        <plan-button-pdf :planId="item.id"></plan-button-pdf>
                                    </div>
                                </md-table-cell>
                            </md-table-row>
                        </md-table>
                        <p v-else>Aucun plan sur ce site</p>
                    </div>
                </div>
            </md-tab>
            <md-tab id="tab-interventions" md-label="Interventions">
                <div class="md-layout md-gutter mt-1">
                    <div class="md-layout-item md-size-100">
                        <span class="text-base font-medium">Dernières interventions</span>
                        <site-interventions v-if="active && site.id" type="site" :siteId="site.id" class="-m-4"></site-interventions>
                    </div>
                </div>
            </md-tab>
        </md-tabs>
    </div>
</template>

<script>
import SiteSchedules from "@/pages/Sites/Informations/components/SiteSchedules";
import ContactsList from "@/pages/Sites/Contacts/components/ContactsList";
import PlanButtonPdf from "@/pages/Sites/Devices/Plans/components/PlanButtonPdf";
import SiteInterventions from "@/components/Tables/DetailInterventionsTable";
export default {
    name: "TabSite",
    components: {
        SiteSchedules, ContactsList, PlanButtonPdf, SiteInterventions
    },
    props: {
        interventionId: Number,
        active: Boolean
    },
    data() {
        return {
            site: {}
        }
    },
    computed: {
        schedules() {
            return this.site.schedules ?? []
        },
        address() {
            return {
                addresses: this.site.address?.addresses ?? 'Ø',
                zip_code: this.site.address?.zip_code ?? 'Ø',
                city: this.site.address?.city ?? 'Ø',
                geo_lat: this.site.address?.geo_lat ?? 'Ø',
                geo_long: this.site.address?.geo_long ?? 'Ø',
            }
        },
        activity() {
            return {
                name: this.site.activity?.name ?? 'Ø'
            }
        },
        sector() {
            return {
                name: this.site.sector?.name ?? 'Ø'
            }
        },
        devices() {
            return this.site.devices ?? []
        },
        plans() {
            return this.site.plans ?? []
        }
    },
    methods: {
        async getSiteDetails() {
            const { data } = await this.$store.dispatch('calendar/getModalSite', {
                interventionId: this.interventionId
            })
            let schedules = this.formatSchedules(data.site.schedules)
            this.site = {
                ...data.site,
                schedules: schedules
            }
        },
        formatSchedules(data) {
            let schedules = []
            data.map(d => {
                let sameSchedule = schedules.filter(s => { return s.day_number === d.day_number })
                if(sameSchedule.length > 0) {
                    sameSchedule[0].schedules.push({
                        id: d.id,
                        start: d.start,
                        end: d.end
                    })
                } else {
                    let schedule = {
                        ...d,
                        schedules: [{
                            id: d.id,
                            start: d.start,
                            end: d.end
                        }]
                    }
                    schedules.push(schedule)
                }
            })
            return schedules
        },
        contactsList(type) {
            return this.site.contacts?.filter(contact => { return contact.pivot.type === type }) ?? []
        },
    },
    mounted() {
        if(this.active) {
            this.getSiteDetails()
        }
    },
    watch: {
        active(newVal) {
            if(newVal) {
                this.getSiteDetails()
            }
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    #schedules.md-list {
        .md-list-item {
            margin-bottom: .15rem;
            margin-left: 0;

            .md-list-item-content {
                font-size: 14px;
                min-height: 18px;
                padding: 0;

                * {
                    width: unset;
                }

                .day {
                    font-weight: 500;
                }
            }
        }
    }
    .md-table {
        &.md-table-devices {
            thead tr th:first-child,
            tbody tr td:first-child {
                padding-left: 0;
            }
            .md-table-cell {
                max-height: 35px;
                height: 35px;
                img {
                    max-width: 15px;
                }
            }
        }
        .md-table-content {
            thead tr th, tbody tr td {
                padding-top: 0;
                padding-bottom: 0;
            }
            .md-table-head-label {
                font-size: 1rem;
                padding: 0;
            }
        }
    }
}
</style>
